export enum PaymentType {
  Affirm = 'affirm',
  AfterPay = 'afterpay',
  Alipay = 'alipay',
  ApplePay = 'applePay',
  CreditCard = 'card',
  Giropay = 'giropay',
  GooglePay = 'googlePay',
  Klarna = 'klarna',
  PayPal = 'payPal',
  PayPalv2 = 'paypal_v2',
  Stripe = 'stripe',
}
